import styled, { css } from 'styled-components';
import getContrastFontColor from '@utils/getContrastFontColor';
import { darken } from 'polished';
import { media } from 'styled-bootstrap-grid';

export const SpinnerWrapper = styled.div<{ $display: boolean }>`
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.defaultColors.lighterGrey};
  height: 126px;
  width: 16vw;
  margin: 5px;
  border-radius: 4px;

  ${({ $display }) =>
    !$display &&
    css`
      display: none;
    `};

  ${media.md`
    margin: 10px;
    width: 7vw;
    max-width: 100px;
  `};

  &:nth-of-type(1) {
    margin-left: 5px;
  }
`;

export const Label = styled.label<{ isPriceVisible: boolean; isLoading: boolean }>`
  position: relative;
  display: inline-block;
  cursor: pointer;
  overflow: hidden;
  text-align: center;
  border-radius: 4px;
  width: 21vw;
  margin: 5px;

  ${media.md`
    width: 7vw;
    max-width: 100px;
  `};
  ${({ isPriceVisible }) =>
    !isPriceVisible &&
    css`
      padding-bottom: 5px;
    `};

  ${({ isLoading }) =>
    isLoading &&
    css`
      display: none;
    `};
`;

export const WeekdayName = styled.span`
  font-size: 14px;
  text-align: left;
  display: block;
  padding: 8px 8px 5px 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: ${({ theme }) =>
    `color, background-color ${theme.transitionTime} ${theme.transitionType}`};
`;
export const DayOfMonth = styled.span`
  display: block;
  font-size: 52px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 68px;
  padding-bottom: 9px;
`;
export const DayPrice = styled.span<{ hasDiscount?: boolean }>`
  display: block;
  padding: 2px 3px;
  background-color: ${({ theme, hasDiscount }) =>
    hasDiscount ? theme.semanticColors.redDark : theme.primaryColour};
  font-size: 15px;
  color: ${({ theme, hasDiscount }) =>
    hasDiscount
      ? theme.defaultColors.white
      : getContrastFontColor(theme.primaryColour, theme.defaultColors.fontPrimary)};
`;

export const RadioInput = styled.input<{
  isPriceVisible: boolean;
  isDataMissing: boolean;
  hasDiscount?: boolean;
}>`
  position: absolute; /* take it out of document flow */
  opacity: 0; /* hide it */
  cursor: pointer;

  & + label:before {
    content: '';
    position: absolute;
    padding: 10px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #f2f2f2;
    border: ${({ theme }) => `1px solid ${theme.defaultColors.lighterGrey}`};
    z-index: -1;
    transition: ${({ theme }) => `opacity ${theme.transitionTime} ${theme.transitionType}`};
    border-radius: 4px;
  }

  ${({ theme, isPriceVisible }) =>
    !isPriceVisible &&
    css`
      & + label:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 5px;
        background: ${theme.primaryColour};
        z-index: 0;
      }
    `};

  &:checked + label {
    color: ${({ theme, hasDiscount }) =>
      hasDiscount
        ? theme.defaultColors.white
        : getContrastFontColor(theme.primaryColour, theme.defaultColors.fontPrimary)};
    & ${DayPrice} {
      background: ${({ theme, hasDiscount }) =>
        darken(
          0.05,
          (hasDiscount ? theme.semanticColors.redDark : theme.primaryColour) || 'white'
        )};
    }
  }

  &:checked + label:before {
    background-color: ${({ theme, hasDiscount }) =>
      hasDiscount ? theme.semanticColors.redDark : theme.primaryColour};
    border-color: ${({ theme, hasDiscount }) =>
      hasDiscount ? theme.semanticColors.redDark : theme.primaryColour};
  }

  ${({ theme, isPriceVisible }) =>
    !isPriceVisible &&
    css`
      &:checked + label:after {
        background: ${darken(0.05, theme.primaryColour || 'white')};
      }
    `};

  &:disabled + label {
    cursor: default;
    color: #c1c1c1;
    &:before {
      background: #fff;
    }
    ${({ theme, isPriceVisible }) =>
      !isPriceVisible &&
      css`
        &:after {
          background: ${theme.defaultColors.lightGrey};
        }
      `};

    ${DayPrice} {
      color: #c1c1c1;
      background: ${({ theme }) => theme.defaultColors.lightGrey};
    }
  }

  ${({ isDataMissing }) =>
    isDataMissing &&
    css`
      & + label {
        opacity: 0.2;
      }
    `}
`;

export const FieldWrapper = styled.div`
  padding-right: 10px;
  ${media.md`
    padding-right: 20px;
  `}
`;
